import * as Styled from './styles';
import { TableCellProps } from './types';

const TableCell = ({ children, ...elementProps }: TableCellProps) => (
  <Styled.TableCell {...elementProps}>{children}</Styled.TableCell>
);
export default TableCell;
